export const Actions = {
    SET_TERRA_APP: 'SET_TERRA_APP',
};
